import React from 'react';
import { ResourceSite } from '../../../hooks/resourceSiteHooks';
import { ResourceRequestMetadata } from '../../types/KanbanTypes';
import RequestItems from './RequestItems';
import LocationDisplay from './LocationDisplay';

interface RequestDetailsProps {
  metadata: ResourceRequestMetadata;
  resourceSites?: ResourceSite[];
}

const RequestDetails: React.FC<RequestDetailsProps> = ({
  metadata,
  resourceSites,
}) => (
  <>
    {/* Show items if available */}
    {metadata.items && metadata.items.length > 0 && (
      <RequestItems
        items={metadata.items}
        totalItemCount={metadata.totalItemCount || metadata.items.length}
      />
    )}

    {/* Show locations */}
    <LocationDisplay metadata={metadata} resourceSites={resourceSites} />

    {/* Show request details */}
    {metadata.supply_sources && (
      <div className="mt-1 small">
        <strong>Supply Sources:</strong> {metadata.supply_sources}
      </div>
    )}
    {metadata.substitutes && (
      <div className="mt-1 small">
        <strong>Substitutes:</strong> {metadata.substitutes}
      </div>
    )}
  </>
);

export default RequestDetails;
